import { type Html, html, rune, View } from 'rune-ts';
import klass from './CreatorSection.module.scss';
import { font } from '../../../../../shared/typography';
import { map, pipe, toArray } from '@fxts/core';
import { staticTypo } from '../../../../../shared/typography/typo';
import { CrossIcon } from '../../../../../shared/components/atoms/Icon/foundation_icons';
import { UtilImageS } from '../../../../../../../modules/Util/Image/S/Function/module/UtilImageS';
import { media_url_info } from '../../constant';

export class CreatorSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <section class="${klass.creator}">
        <div class="${klass.content}">
          <div class="${font('48_bold', '28_bold')}">마플샵 크리에이터</div>
          <div class="${klass.data} ${staticTypo('bebas_90_bold')}">
            90,000 ${CrossIcon({ klass: klass.cross_icon })}
          </div>
          <div class="${klass.description} ${font('28_medium', '14_medium')}">
            <p>마플샵의 <span>9만 명이 넘는 크리에이터</span> 가 함께 합니다</p>
            <p>크리에이터를 가장 잘 아는 커머스, 마플샵에서</p>
            <p><span>내 채널과 딱 맞는 브랜드</span> 를 매칭해드립니다</p>
          </div>
        </div>
        <div class="${klass.creators}">
          ${is_mobile
            ? html`
                <ul>
                  ${pipe(
                    media_url_info.creator_section.creator_image_urls_mo_top,
                    map(
                      (url) =>
                        html`<li>
                          <img src=${url} alt="크리에이터 예시 이미지" />
                        </li>`,
                    ),
                    toArray,
                  )}
                </ul>
                <ul>
                  ${pipe(
                    media_url_info.creator_section.creator_image_urls_mo_mid,
                    map(
                      (url) =>
                        html` <li>
                          <img src=${url} alt="크리에이터 예시 이미지" />
                        </li>`,
                    ),
                    toArray,
                  )}
                </ul>
                <ul>
                  ${pipe(
                    media_url_info.creator_section.creator_image_urls_mo_bottom,
                    map(
                      (url) =>
                        html` <li>
                          <img src=${url} alt="" />
                        </li>`,
                    ),
                    toArray,
                  )}
                </ul>
              `
            : html`<div class="${klass.marquee_wrapper} ${klass.top}">
                  <div class="${klass.marquee_background}">
                    ${pipe(
                      media_url_info.creator_section.creator_top_image_urls,
                      map((url) =>
                        UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' }),
                      ),
                      map((src) => html`<img src="${src}" alt="marquee-product" />`),
                      toArray,
                    )}
                  </div>
                  <div class="${klass.marquee_background} ${klass.bottom}" aria-hidden="true">
                    ${pipe(
                      media_url_info.creator_section.creator_bottom_image_urls,
                      map((url) =>
                        UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' }),
                      ),
                      map((src) => html`<img src="${src}" alt="marquee-product" />`),
                      toArray,
                    )}
                  </div>
                </div>
                <div class="${klass.marquee_wrapper} ${klass.bottom}">
                  <div class="${klass.marquee_background}">
                    ${pipe(
                      media_url_info.creator_section.creator_top_image_urls,
                      map((url) =>
                        UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' }),
                      ),
                      map((src) => html`<img src="${src}" alt="marquee-product" />`),
                      toArray,
                    )}
                  </div>
                  <div class="${klass.marquee_background} ${klass.bottom}" aria-hidden="true">
                    ${pipe(
                      media_url_info.creator_section.creator_bottom_image_urls,
                      map((url) =>
                        UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' }),
                      ),
                      map((src) => html`<img src="${src}" alt="marquee-product" />`),
                      toArray,
                    )}
                  </div>
                </div>`}
        </div>
      </section>
    `;
  }
}
